$(function () {
  /* 初期化処理 */
  ssss();
  $('.js-slider').slick({
    autoplay: true,
    arrows: false,
    dots: true,
    fade: true,
    speed: 2000
  });

  /* 初期化処理 */
  $(window).on('resize', function () {
    ssss();
  });
});

const ssss = function () {
  /* ファーストビューの高さはウィンドウの高さ */
  const topImageHeight = $(window).height() - 96;
  $('.topImage-wrapper').height(topImageHeight);

  /* スライドの高さをヘッダーとスライダーの上下の空きを引いた数値にします */
  const slideHeight = $(window).height() - 96 - 24 - 60;
  $('.slide').height(slideHeight);
};
